// this file dictates some functionalities and animations of scss fk_ui components. I didnt know what else to name this file lol
import delegate from './delegate';

const init = function () {
	// NOTE: click handlers for `.status-block-close`, `#sidebar_toggle`, and
	// `[data-change-theme]` are registered via the CSP-compliant document
	// delegate in resources/views/components/csp-delegates.blade.php.
	// Do not re-bind them here or they will fire twice per click.

	// status blocks
	window.__.closeStatusBlock = function (button) {
		let block = button.closest('.status-block');
		anime({
			targets: block,
			height: 0,
			opacity: 0,
			duration: 400,
			paddingBottom: 0,
			paddingTop: 0,
			marginBottom: 0,
			marginTop: 0,
			easing: 'easeInOutExpo',
			update: function () {
				block.classList.add('closed');

				// check the parent of the status block to see if there are any other status blocks
				// if there are none, then add the no-status-blocks class to the parent
				let parent = block.closest('.status-banner');

				if (parent?.querySelectorAll('.status-block:not(.closed)').length === 0) {
					// animate the parent out
					parent.classList.add('animate__fadeOutUp');
				}
			}
		})
	}
	// initialize an intersection observer to watch for visibility of elements
	const observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				entry.target.classList.add('animate__fadeInUp');
				observer.unobserve(entry.target);
			}
		})
	})


	// initialize a mutation observer to watch for changes in the DOM
	// const observer = new MutationObserver(function (mutations) {
	// 	mutations.forEach(function (mutation) {
	// 		if (mutation.type !== 'childList') return;
	// 		const addedNodes = mutation.addedNodes;

	// 		addedNodes.forEach(function (node) {
	// 			// initialize range slider
	// 			if (node.nodeType === Node.ELEMENT_NODE && node.matches('.range-slider input[type="range"]')) {
	// 				setRangeSliderValue(slider)
	// 			}
	// 		})
	// 	})
	// })

	// observer.observe(document.body, {
	// 	childList: true,
	// 	subtree: true
	// })
	// range sliders

	// if datastep is 1, round to nearest integer, if 2 then round to nearest 2, if 0.1 then round to nearest 0.1
	function roundToStep(value, dataStep = 1) {
		value = Number(value)
		let newValue = value % dataStep >= dataStep / 2 ? value + dataStep - value % dataStep : value - value % dataStep;
		return Math.round(newValue);
	}

	window.__.setRangeSliderValue= function(slider) {
		const span = slider.closest('.range-slider').querySelector('.range-value');
		if (span === null) return;

		const value = slider.value;
		const totalInputWidth = slider.offsetWidth;
		const thumbHalfWidth = 7;
		const dataStep = Number(slider.getAttribute('data-step'));
		const maxValue = Number(slider.getAttribute('max'));
		const minValue = Number(slider.getAttribute('min'));

		span.innerHTML = roundToStep(slider.value, dataStep) + '%';
		// get the thumb position of the range slider
		let left = (((value - minValue) / (maxValue - minValue)) * ((totalInputWidth - thumbHalfWidth) - thumbHalfWidth)) + thumbHalfWidth;
		left = left - span.offsetWidth / 2;
		span.style.left = `${left}px`;
	}

	delegate({
		selector: `.range-slider input[type="range"]`,
		event: 'input',
		handler: function (slider) {
			__.setRangeSliderValue(slider);
		}
	})

	delegate({
		selector: `.range-slider input[type="range"]`,
		event: 'mouseup',
		handler: function (slider) {
			anime({
				targets: slider,
				value: roundToStep(slider.value),
				duration: 200,
				easing: 'easeOutQuad',
				update: function (anim) {
					// dispatch an input to the document to trigger the input event listener with slider as the range slider
					__.setRangeSliderValue(slider);
				}
			});
		}
	})
	// initialize range slider
	document.querySelectorAll('.range-slider input[type="range"]').forEach(function (slider) {
		__.setRangeSliderValue(slider)
	})
}

export default init;